import { apiClient } from './client';

/** A role a participant can take in a recording (ROLES-AND-GO) — Primary
 *  nurse, Secondary nurse, … — picked on the capture app when the tenant
 *  turns roles on. */
export interface SessionRole {
  id: string;
  name: string;
  sort_order: number;
  /** Archived roles stay on the recordings that used them, but aren't offered. */
  archived_at: string | null;
  /** Recordings that used this role; a used role is archived, not deleted. */
  used_count: number;
}

const base = (tenantId: string) => `/api/v1/tenants/${tenantId}/session-roles`;

export async function listSessionRoles(tenantId: string): Promise<SessionRole[]> {
  const { data } = await apiClient.get<SessionRole[]>(base(tenantId));
  return data;
}

export async function createSessionRole(tenantId: string, name: string): Promise<SessionRole> {
  const { data } = await apiClient.post<SessionRole>(base(tenantId), { name });
  return data;
}

export async function updateSessionRole(
  tenantId: string,
  roleId: string,
  patch: { name?: string; archived?: boolean },
): Promise<SessionRole> {
  const { data } = await apiClient.patch<SessionRole>(`${base(tenantId)}/${roleId}`, patch);
  return data;
}

/** Deletes a role no recording used; archives one that is in use. */
export async function removeSessionRole(
  tenantId: string,
  roleId: string,
): Promise<'deleted' | 'archived'> {
  const { data } = await apiClient.delete<{ outcome: 'deleted' | 'archived' }>(
    `${base(tenantId)}/${roleId}`,
  );
  return data.outcome;
}

export async function reorderSessionRoles(tenantId: string, ids: string[]): Promise<void> {
  await apiClient.put(`${base(tenantId)}/order`, { ids });
}
